import { entitlementLabel, learnerInitials } from "@/lib/auditSheetLabels";

export default function InstructorLearnerHeader({
  learner,
  programmeLabel,
  sessionDate,
  sessionTimeAmPm,
  pickerOpen,
  onTogglePicker,
  onSwitchClick,
}) {
  if (!learner) {
    return (
      <section className="audit-surface audit-learner-header" aria-label="Selected learner" data-testid="audit-learner-header-empty">
        <p className="text-sm" style={{ color: "rgba(22,25,28,.72)" }}>
          Select a learner to begin instructor training.
        </p>
        <button
          type="button"
          className="audit-btn-outline-dark"
          onClick={onSwitchClick}
          aria-expanded={pickerOpen}
          data-testid="audit-switch-learner"
        >
          Switch learner
        </button>
      </section>
    );
  }

  const trainingEnabled = learner.training_entitlement === "TRAINING_ENABLED";

  return (
    <section className="audit-surface audit-learner-header" aria-label="Selected learner" data-testid="tr-learner-bound">
      <div className="audit-learner-avatar" aria-hidden="true">
        {learnerInitials(learner.display_name)}
      </div>
      <div className="audit-learner-meta">
        <h1 className="audit-learner-name" data-testid="tr-learner-display">
          {learner.display_name}
        </h1>
        <div className="audit-badge-row">
          <span
            className={`audit-badge ${trainingEnabled ? "training-enabled" : ""}`}
            data-testid="tr-entitlement-display"
          >
            {entitlementLabel(learner.training_entitlement)}
          </span>
          <span className="audit-badge" data-testid="tr-programme-display">
            {programmeLabel} · {sessionDate} · {sessionTimeAmPm}
          </span>
        </div>
      </div>
      <button
        type="button"
        className="audit-btn-outline-dark"
        onClick={onSwitchClick}
        aria-expanded={pickerOpen}
        data-testid="audit-switch-learner"
      >
        Switch learner
      </button>
    </section>
  );
}
